import React, { useEffect, useState } from "react";
import Button, {
  ButtonTypes,
  ButtonColorTypes,
} from "../shared-components/Button";
import { XIcon } from "../shared-components/icons";
import InputField from "../shared-components/InputField";
import Divider from "../shared-components/LineDivider";
import { classNames, uniqueUUID } from "../utils";
import { PersonFormStateError } from "./PersonFormErrorState";

export interface EmailDefinitions {
  key: string;
  email: string;
}

type Props = {
  onChange?: (emails: EmailDefinitions[]) => void;
  error?: PersonFormStateError;
  prefill?: EmailDefinitions[];
  alternateColor?: boolean;
};

function buildEmptyDefinition(): EmailDefinitions {
  return { email: "", key: uniqueUUID() };
}

const PersonFormEmails = ({
  onChange,
  error,
  prefill,
  alternateColor,
}: Props) => {
  const [fieldsList, setFields] = useState<EmailDefinitions[]>([
    buildEmptyDefinition(),
  ]);

  useEffect(() => {
    if (prefill && prefill.length > 0) {
      handleChange([...prefill]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefill]);

  const appendFields = () => {
    handleChange([...fieldsList, buildEmptyDefinition()]);
  };

  const updateField = (idx: number, field: "email", value: string) => {
    fieldsList[idx][field] = value;
    handleChange([...fieldsList]);
  };

  const removeField = (idx: number) => {
    fieldsList.splice(idx, 1);
    handleChange([...fieldsList]);
  };

  const handleChange = (list: EmailDefinitions[]) => {
    onChange?.(list);
    setFields(list);
  };

  const handleAdd = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    appendFields();
  };

  const handleRemove = (idx: number) => {
    removeField(idx);
  };

  return (
    <>
      <div>
        {fieldsList.map((fields, idx) => (
          <div
            key={fields.key}
            className={classNames(
              "flex flex-wrap items-center",
              idx > 0 ? "mt-4" : ""
            )}
          >
            <InputField
              handleChange={(e) => {
                updateField(idx, "email", e.target.value);
              }}
              defaultValue={fields.email}
              name={`email-${idx}`}
              placeholder=""
              value={fieldsList[idx].email}
              label={"Email Address*"}
              type="email"
              className={`${error?.emails?.[idx] ? "border-rose-600" : ""}`}
            />
            {fieldsList.length > 1 && (
              <span className="pl-2 h-0">
                <div
                  className="rounded-full bg-gray-50 border p-1 text-gray-500 cursor-pointer"
                  onClick={(e) => handleRemove(idx)}
                >
                  <XIcon />
                </div>
              </span>
            )}
          </div>
        ))}
      </div>
      <Divider className="mb-6" />
      <Button
        type={ButtonTypes.add}
        text="Add Email Address"
        colorType={
          alternateColor ? ButtonColorTypes.alternate : ButtonColorTypes.action
        }
        onClick={handleAdd}
      />
    </>
  );
};

export default PersonFormEmails;
